import { useState, useEffect } from 'react';
import { _UBLInvoiceDoc } from '../../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const UBLInventoryEntryDocument = ({ idSelector, onChange, label }: Props) => {

    const ubl = useDataBean(_UBLInvoiceDoc);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<any>(idSelector ?? "");

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
            ////console.log(idSelector)
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        const selectedID = e; // <-- deja el string tal cual
        onChange(selectedID);
    };

    const getLista = () => {
        ubl.instance.getUBLInventoryEntryDocumentTypes(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Tipo Documento Contable:"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
